import { useCurrentUserWorkspaceMember } from '~/hooks'
import { HITLChat } from './HITLChat'
import { useNavigate } from '@tanstack/react-router'
import { Conversation } from '@botpress/hitl-client'

type Props = {
  conversation: Conversation
  botId: string
  workspaceId: string
}

const HITLTabs = ({ conversation, botId, workspaceId }: Props) => {
  const currentWorkspaceMember = useCurrentUserWorkspaceMember({ workspaceId })
  const navigate = useNavigate()

  const isAssignedToMe = conversation.assignee?.workspaceMemberId === currentWorkspaceMember!.id

  if (conversation.status === 'solved') {
    navigate({ to: '/workspaces/$workspaceId/bots/$botId/hitl', params: { botId, workspaceId } })
  }

  return (
    <HITLChat
      botId={botId}
      conversation={conversation}
      workspaceId={workspaceId}
      assignedToCurrentUser={isAssignedToMe}
    />
  )
}

export { HITLTabs }
